document.addEventListener('DOMContentLoaded', function () {
	const openQuickViewButtons = document.querySelectorAll('.open-quick-view');
	const quickViewModal = document.getElementById('quick-view-modal');

	openQuickViewButtons.forEach(button => {
		button.addEventListener('click', function () {
			quickViewModal.style.display = 'block';
			const productUrl = button.getAttribute('data-product');
			fetch(`${productUrl}?view=modal`)
				.then(response => response.text())
				.then(responseText => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector('.quick-view__content');
					$(".qv-product-content").append(productElement.innerHTML)
					// setTimeout(() => {
					// 	const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					// 	const productElement = responseHTML.querySelector(selector);
					// 	this.setInnerHTML(drawerContent, productElement.innerHTML);
	
					// 	if (window.Shopify && Shopify.PaymentButton) {
					// 		Shopify.PaymentButton.init();
					// 	}
					}, 200);
		});
	});

	$('.close-quick-view').on('click', function () {
		quickViewModal.style.display = 'none';
		$(".qv-product-content").empty();
	});

	window.addEventListener('click', function (event) {
		if (event.target === quickViewModal) {
			quickViewModal.style.display = 'none';
			$(".qv-product-content").empty();
		}
	});
});